<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">Independent Product Review &amp; Marketplace Trust Layer</h1>

        <section class="content-section">
            <p class="desc-text">XigCheck is the dedicated product review and marketplace trust support layer affiliated with the XigFor marketplace platform.</p>
            <p class="desc-text">It is designed to support trust, transparency, and marketplace integrity for selected high-value second-hand product categories.</p>
        </section>

        <section class="content-section">
            <p class="desc-text">XigCheck provides product review services for eligible products, including:</p>
            <ul class="policy-list">
                <li>Luxury handbags</li>
                <li>Luxury accessories</li>
                <li>Premium sneakers</li>
                <li>Selected collectible fashion items</li>
            </ul>
        </section>

        <section class="content-section">
            <p class="desc-text">Authentication review services may involve:</p>
            <ul class="policy-list">
                <li>AI-assisted review tools</li>
                <li>Visual product analysis</li>
                <li>Expert-assisted assessment</li>
                <li>Independent third-party review support</li>
            </ul>
        </section>

        <section class="content-section">
            <p class="desc-text">Certain authentication reviews may be supported by independent authentication service providers operating under separate service agreements.</p>
            <p class="desc-text">XigCheck is intended solely for marketplace trust support and authentication review purposes.</p>
        </section>

        <section class="content-section">
            <p class="desc-text">XigCheck does not:</p>
            <ul class="policy-list">
                <li>provide financial services</li>
                <li>operate escrow functionality</li>
                <li>provide Transaction Guarantees</li>
                <li>hold or custody user funds</li>
                <li>provide insurance services</li>
                <li>support cryptocurrency-related or token exchange services</li>
            </ul>
        </section>

        <section class="content-section">
            <p class="desc-text">All payments are processed directly through approved third-party payment service providers such as PayPal or Stripe.</p>
            <p class="desc-text">Review outcomes represent independent assessment opinions only and do not constitute financial guarantees or investment-related services.</p>
            <p class="desc-text">XigCheck operates in accordance with applicable platform compliance policies, marketplace integrity standards, and fraud prevention procedures.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckTrustLayer'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
